import React, { useState, useRef, useEffect } from 'react'

import styled, { ThemeProvider } from 'styled-components'
import { lightTheme, darkTheme, GlobalStyles } from '../themes.js'
import './styles/contact.scss'

function Contact(themeData) {

  useEffect(() => {
    document.title = 'Contact • IBIS GlobaLink Co., Ltd..';
  }, []);
  
    return (
      <ThemeProvider
        theme={themeData.theme === "light" ? lightTheme : darkTheme}
      >
        <GlobalStyles />
        <div id="contact">
          <section className="contact section-top section-bottom">
            <div className="pagetopMargin"></div>
            <div className="wrapper">
              <div className="flex flex-column">
                <span className="title">Contact Us</span>
              </div>
            </div>

            <div className="wrapper">
              <div className="type-container">
                <span className="type">
                  We can help you solve your logistics problems. Please contact
                  us with any questions you may have.
                </span>
              </div>
            </div>

            <div className="wrapper">
              <div className="contact-container">
                <div className="right">
                  <div className="each-info">
                    <div className="border-left"></div>
                    <div className="content-info">
                      <span className="title-info">Company Name</span>
                      <span className="details">IBIS GlobaLink Co., Ltd..</span>
                    </div>
                  </div>
                  <div className="each-info">
                    <div className="border-left"></div>
                    <div className="content-info">
                      <span className="title-info">Contact Person</span>
                      <span className="details">Kenya Ishii</span>
                    </div>
                  </div>
                  <div className="each-info">
                    <div className="border-left"></div>
                    <div className="content-info">
                      <span className="title-info">Telephone</span>
                      <span className="details">81-3-6260-5020</span>
                    </div>
                  </div>
                  <div className="each-info">
                    <div className="border-left"></div>
                    <div className="content-info">
                      <span className="title-info">Fax</span>
                      <span className="details">81-3-6260-5021</span>
                    </div>
                  </div>
                  <div className="each-info">
                    <div className="border-left"></div>
                    <div className="content-info">
                      <span className="title-info">Email</span>
                      <span className="details">logi@ibis-globalink.co.jp</span>
                    </div>
                  </div>
                  <div className="each-info">
                    <div className="border-left"></div>
                    <div className="content-info">
                      <span className="title-info">Head Office Address</span>
                      <span className="details">
                        6F Hatsune Mori Bldg, 2-27-9 Higashi-Nihonbashi, Chuo-ku,
                        Tokyo, Japan, 103-0004
                      </span>
                    </div>
                  </div>
                  {/* <div className='each-info'>
                    <div className='border-left'></div>
                    <div className='content-info'>
                      <span className='title-info'>Content of Details</span>
                      <span className='details'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span>
                    </div>
                  </div> */}
                </div>
                {/* <div className='left'>
                  <a href={`https://api.whatsapp.com/send?phone=639669401886`}>
                  <div className='each-contact wa'>
                    <div className='lord-icon'>
                      <lord-icon className='lord'
                          src="https://cdn.lordicon.com/dnphlhar.json"
                          trigger="loop"
                          delay="2000"
                          stroke="bold"
                          colors="primary:#ffffff,secondary:#ffffff"
                          style={{ width: "80px", height: "80px" }}>
                      </lord-icon>
                    </div>
                    <div className='name'>WhatsApp</div>
                  </div>
                  </a>
                  <a target="_blank" rel="noopener noreferrer" href="">
                  <div className='each-contact ln'>
                    <div className='lord-icon'>
                      <lord-icon className='lord'
                          src="https://cdn.lordicon.com/qgebwute.json"
                          trigger="loop"
                          delay="2000"
                          stroke="bold"
                          colors="primary:#ffffff,secondary:#ffffff"
                          style={{ width: "80px", height: "80px" }}>
                      </lord-icon>
                    </div>
                    <div className='name'>LinkedIn</div>
                  </div>
                  </a>
                </div> */}
                <div className="left">
                  <iframe
                    title="Ibis GlobaLink Location"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    loading="lazy"
                    allowFullScreen
                    referrerPolicy="no-referrer-when-downgrade"
                    src="https://www.google.com/maps?q=35.69524,139.78538&z=16&output=embed"
                  ></iframe>
                </div>
              </div>
            </div>
          </section>
        </div>
      </ThemeProvider>
    );
}

export default Contact;